import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from "../../redux/actions";
import tipsIcon from '../../assets/icons/tipsIcon.png';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const WebViewPrompt = () => {
  const dispatch = useDispatch();

  const [clicked, setClicked] = useState(false)

  const onClose = e => {
    dispatch(actions.setWebViewPrompt(false));
  };

  return (
    <div className="WebViewPrompt">
      <div className="WebViewPrompt-Content">
        <section className="Close-Modal" >
          <button onClick={onClose}>X</button>
        </section>
        <hr />
        <section className="Modal-Header">
          <h2>View in Augmented Reality</h2>
        </section>
        <hr />
        <section className="Prompt-Body">
          <div className="Prompt-Tips">
            <section className="Prompt-Row">
              <section className="Prompt-Icon">
                <img src={tipsIcon} alt="Double Tap Device" />
              </section>
              <section className="Prompt-Copy">
                <h5>No Quicklook Browser Support</h5>
                <p>Please copy this link into Safari or Chrome to continue to your curated experience.</p>
              </section>
            </section>
          </div>
        </section>
        <hr />
        <section className="WebViewPrompt-Footer">
        <CopyToClipboard text={window.location.href}>
          <button type="submit"
                  className="downloadBtn"
                  variant="contained"
                  onClick={() => setClicked(!clicked)}>
                  { !clicked ? ("Copy Link") : ("Copied!") }
          </button>
          </CopyToClipboard>
          <button onClick={onClose}>Exit</button>
        </section>
      </div>
    </div>
  );
};

export default WebViewPrompt;
